import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { Avatar } from 'components/shared/Avatar/Avatar'
import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { ChevronDownIcon, Icon } from 'components/shared/Icon/Icon'

import styles from './UserProfileAnchor.module.scss'

export const UserProfileAnchor = ({ user }) => (
  <Dropdown.Anchor className={styles.anchor}>
    <Box align="flex-end" direction="column" tagName="span">
      <span className={styles.name}>{user?.name}</span>
      <span className={styles.company}>{user?.companyName}</span>
    </Box>
    <Icon className={styles.icon} icon={ChevronDownIcon} size="24" />
    <Avatar {...{ user }} />
  </Dropdown.Anchor>
)
